import styled from "styled-components";

export const Container = styled.div`
    width: 100vw;
    height: 100vh; 
    // background: ${({ theme }) => theme.colors.primaryBlue600};
    background: ${({ theme }) => theme.colors.interfacePure100};
`

export const Header = styled.div`
    width: 1040px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 48px;     
`

export const Main = styled.div`
    width: 1040px;
    min-height: 600px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 20px;

    .image {
        width: 100%;
        img {
            width: 420px;
        }
    }

    .status {
        height: 336px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .progress {
            display: flex;
            align-items: center;
            gap: 8px;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            margin-bottom: 24px;
            .progress-bar {
                height: 8px;
                width: 172px;
                border-radius: 8px;
                background: ${({ theme }) => theme.colors.primaryRed400};                        
            }
        }

        .status-title {
            /* max-width: 236px; */
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            font-size: 24px;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 16px;
        }

        .status-subtitle {
            max-width: 424px;
            min-height: 80px;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            margin-bottom: 32px;

            span {
                font-weight: 600;
            }

            .status-id {
                max-width: 424px;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
                font-size: 18px;
                font-weight: 400;
                line-height: 32px;
            }
        }


        .buttons {
            display: flex;
            width: 424px;
            gap: 16px;
            .new {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 248px;
                height: 40px;
                border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
                border-radius: 8px;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
                transition: all .3s;
                cursor: pointer;
                &:hover {
                    transform: scale(1.05);
                }
            }

            .continue {
                max-width: 160px;
                height: 40px;
                background-color: ${({ theme }) => theme.colors.primaryRed400};
            }
        }
    }
`
